import React, { Suspense, lazy } from "react";
import { PageNotfond, Spinner } from "../Components";
import AuthGuard from "../Middleware/AuthGuard";
import AppointmentGuard from "../Middleware/AppointmentGuard";
import AuthDoctorGuard from "../Middleware/AuthDoctorGuard";
import GuardAdmin from "../Middleware/GuardAdmin";
import VerificationEmailGuard from "../Middleware/VerificationEmailGuard";
import DoctorEmailVerification from "../Middleware/DoctorEmailVerification";
import DoctorsConfirmationGuard from "../Middleware/DoctorsConfirmationGuard";

// Public pages load with the main bundle
import Home from "../Pages/Home";
import SearchDoctors from "../Pages/SearchDoctors";
import Login from "../Pages/Login";
import Signup from "../Pages/Signup";
import BookingAppointment from "../Pages/BookingAppointment";
import Aboutus from "../Pages/Aboutus";
import ContactUs from "../Pages/ContactUs";
import DoctorPage from "../Pages/DoctorPage";
import PrivacyPolicy from "../Pages/PrivacyPolicy";
import RefundPolicy from "../Pages/RefundPolicy";
import TermsOfUse from "../Pages/TermsOfUse";
import PaymentTerms from "../Pages/PaymentTerms";
import BlogDetail from "../Pages/BlogDetail";
import ForgotPassword from "../Pages/ForgotPassword";
import DoctorsLogin from "../Pages/AuthDoctors/Login";
import DoctorsSignup from "../Pages/AuthDoctors/Signup";
import DoctorForgotPassword from "../Pages/AuthDoctors/ForgotPassword";
import DoctorsVerificationEmail from "../Pages/AuthDoctors/VerificationEmail";
import UserVerifeyEmail from "../Pages/Users/VerifeyEmail";
import AuthAdmin from "../Pages/Admin/Auth/AuthAdmin";
import DoctorBlog from "../Components/DoctorBlog";
import DoctorConsultations from "../Components/DoctorConsultations";
import PaymentPage from "../Components/PaymentPage";

// Dashboards, video calls and payments load on demand
const lazyPage = (load) => {
  const Page = lazy(load);
  return (props) => (
    <Suspense
      fallback={
        <div className="flex h-screen items-center justify-center">
          <Spinner />
        </div>
      }
    >
      <Page {...props} />
    </Suspense>
  );
};

const VideoRoom = lazyPage(() => import("../Pages/VideoRoom"));
const OnlinePayment = lazyPage(() => import("../Components/OnlinePayment"));

const UserProfile = lazyPage(() => import("../Pages/Users/Profile"));
const UserSettings = lazyPage(() => import("../Pages/Users/Settings"));
const UserChangePassword = lazyPage(() => import("../Pages/Users/ChangePassword"));
const AppointmentTable = lazyPage(() => import("../Pages/Users/AppointmentTable"));
const Prescriptions = lazyPage(() => import("../Pages/Users/Prescriptions"));

const DocotrDashboard = lazyPage(() => import("../Pages/Doctors/Dashboard"));
const DoctorRendezVous = lazyPage(() => import("../Pages/Doctors/RendezVous"));
const DoctorHistorique = lazyPage(() => import("../Pages/Doctors/Historique"));
const DocotrSettings = lazyPage(() => import("../Pages/Doctors/Settings"));
const AboutMe = lazyPage(() => import("../Pages/Doctors/AboutMe"));
const DoctorsConfirmation = lazyPage(() => import("../Pages/Doctors/WhaitingConfirmation"));

const DashboardAdmin = lazyPage(() => import("../Pages/Admin/Dashboard"));
const DoctorsList = lazyPage(() => import("../Pages/Admin/DoctorsList"));
const PatientsList = lazyPage(() => import("../Pages/Admin/PationList"));
const NoVerifiedDoctors = lazyPage(() => import("../Pages/Admin/NoVerifiedDoctors"));
const AdminAppointments = lazyPage(() => import("../Pages/Admin/AdminAppointments"));
const Payments = lazyPage(() => import("../Pages/Admin/Payments"));
const DoctorDashboard = lazyPage(() => import("../Pages/Admin/DoctorDashboard"));
const UserDashboard = lazyPage(() => import("../Pages/Admin/UserDashboard"));
const AdminBlogs = lazyPage(() => import("../Pages/Admin/Blogs"));
const AdminBlogEditor = lazyPage(() => import("../Pages/Admin/BlogEditor"));

const { createBrowserRouter } = require("react-router-dom");

const router = createBrowserRouter([
  {
    path: "/",
    errorElement: <PageNotfond />,
    element: <Home />,
  },
  {
    path: "/About",
    element: <Aboutus />,
  },
  {
    path: "/Contact",
    element: <ContactUs />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/refund-policy",
    element: <RefundPolicy />,
  },
  {
    path: "/terms-of-use",
    element: <TermsOfUse />,
  },
  {
    path: "/payment-terms",
    element: <PaymentTerms />,
  },
  {
    path: "/doctor/View_Profile/:id",
    element: <DoctorPage />,
  },
  {
    path: "/search-doctor",
    element: <SearchDoctors />,
  },
  {
    path: "/room/:roomId",
    element: (
      <VideoRoom />
    )
  },
  {
    path: "/user-login",
    element: <Login />,
  },
  {
    path: "/user-signup",
    element: <Signup />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPassword />,
  },
  {
    path: "/bookingappointment/:id",
    element: (
      <AppointmentGuard>
        <BookingAppointment />
      </AppointmentGuard>
    ),
  },

  // Users Router

  {
    path: "/user/verifeyemail",
    element: (
      <VerificationEmailGuard>
        <UserVerifeyEmail />
      </VerificationEmailGuard>
    ),
  },

  {
    path: "/user/profile",
    element: (
      <AuthGuard>
        <UserProfile />
      </AuthGuard>
    ),
  },

  {
    path: "/user/settings",
    element: (
      <AuthGuard>
        <UserSettings />
      </AuthGuard>
    ),
  },
  
  {
    path: "/user/changepassword",
    element: (
      <AuthGuard>
        <UserChangePassword />
      </AuthGuard>
    ),
  },

  {
    path: "/user/booked-appointments",
    element: (
      <AuthGuard>
        <AppointmentTable/>
      </AuthGuard>
    )
  },

  {
    path: "/user/prescriptions",
    element: (
      <AuthGuard>
        <Prescriptions/>
      </AuthGuard>
    )
  },


  //Doctors Router
  {
    path: "/doctor/login",
    element: <DoctorsLogin />,
  },
  {
    path: "/doctor/forgot-password",
    element: <DoctorForgotPassword />,
  },
  {
    path: "/doctor/signup",
    element: <DoctorsSignup />,
  },

  {
    path: "/doctor/dashboard",
    element: (
      <AuthDoctorGuard>
        <DocotrDashboard />
      </AuthDoctorGuard>
    ),
  },
  {
    path: "/doctor/rendezvous",
    element: (
      <AuthDoctorGuard>
        <DoctorRendezVous />
      </AuthDoctorGuard>
    ),
  },
  {
    path: "/doctor/historique",
    element: (
      <AuthDoctorGuard>
        <DoctorHistorique />
      </AuthDoctorGuard>
    ),
  },
  {
    path: "/doctor/settings",
    element: (
      <AuthDoctorGuard>
        <DocotrSettings />
      </AuthDoctorGuard>
    ),
  },
  {
    path: "/doctor/about-me",
    element: (
      <AuthDoctorGuard>
        <AboutMe />
      </AuthDoctorGuard>
    ),
  },
  {
    path: "/doctor/verifyemail",
    element: (
      <DoctorEmailVerification>
        <DoctorsVerificationEmail />
      </DoctorEmailVerification>
    ),
  },
  {
    path: "/doctor/confirmation",
    element: (
      <DoctorsConfirmationGuard>
        <DoctorsConfirmation />
      </DoctorsConfirmationGuard>
    ),
  },

  // ADMIN ROUTE

  {
    path: "/admin/login",
    element: <AuthAdmin />,
  },
  {
    path: "/admin/dashboard",
    element: (
      <GuardAdmin>
        <DashboardAdmin />
      </GuardAdmin>
    ),
  },
  {
    path: "/admin/doctors",
    element: (
      <GuardAdmin>
        <DoctorsList />
      </GuardAdmin>
    ),
  },
  {
    path: "/admin/doctors/noverified",
    element: (
      <GuardAdmin>
        <NoVerifiedDoctors />
      </GuardAdmin>
    ),
  },
  {
    path: "/admin/patients",
    element: (
      <GuardAdmin>
        <PatientsList />
      </GuardAdmin>
    ),
  },
  {
    path: "/admin/appointments",
    element: (
      <GuardAdmin>
        <AdminAppointments />
      </GuardAdmin>
    ),
  },
  {
    path: "/admin/payments",
    element: (
      <GuardAdmin>
        <Payments />
      </GuardAdmin>
    ),
  },
  {
    path: "/admin/doctor-dashboard/:id",
    element: (
      <GuardAdmin>
        <DoctorDashboard />
      </GuardAdmin>
    ),
  },
  {
    path: "/admin/user-dashboard/:id",
    element: (
      <GuardAdmin>
        <UserDashboard />
      </GuardAdmin>
    ),
  },
  {
    path: "/admin/blogs",
    element: (
      <GuardAdmin>
        <AdminBlogs />
      </GuardAdmin>
    ),
  },
  {
    path: "/admin/blogs/new",
    element: (
      <GuardAdmin>
        <AdminBlogEditor />
      </GuardAdmin>
    ),
  },
  {
    path: "/admin/blogs/:id/edit",
    element: (
      <GuardAdmin>
        <AdminBlogEditor />
      </GuardAdmin>
    ),
  },


  {
    path: "/blogs",
    element: <DoctorBlog />,
  },
  {
    path: "/blog/:slug",
    element: <BlogDetail />,
  },
  {
    path: "/doctorConsultations",
    element: <DoctorConsultations />,
  },

{
  path: "/payment",
  element: <PaymentPage />,
},

{
  path: "/onlinepayment",
  element: <OnlinePayment/>,
},

]);

// Open every new page at the top (Back/Forward keep the browser's scroll position)
let lastLocationKey = router.state.location.key;
router.subscribe(({ location, historyAction }) => {
  if (location.key === lastLocationKey) return;
  lastLocationKey = location.key;
  if (historyAction !== "POP" && !location.hash) {
    window.scrollTo(0, 0);
  }
});

export default router;
